module.exports = __webpack_public_path__ + "img/2_96.2c76e83a.png";